/* eslint-disable @nx/enforce-module-boundaries */
import React, { useContext, useEffect, useState } from 'react';
import {
  HStack,
  Box,
  Card,
  CardBody,
  Stack,
  Button,
  Divider,
  IconButton,
  Tooltip,
  Heading,
  Text,
  Wrap,
  WrapItem,
  Spinner,
  MenuButton,
  MenuList,
  MenuItem, 
  Menu,
  useDisclosure
} from '@mybridge/ui';
import { Tab, TabList, Tabs, TabPanels, TabPanel } from '@mybridge/ui/tabs';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import { MyNetworkContext } from 'v4/components/network/context';
import { SearchCardSkeleton } from 'v4/snippets/search/search-card-skeleton';
import { MyNetworkCircleFilters } from '../../network/my-circle-filters';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import {
  ChatIcon,
  FollowIcon,
  FollowingIcon,
  HandShakeSimpleIcon,
  NetworkChatIcon,
  ThreeDot,
  ThreeDotsIcon,
} from '@mybridge/icons';

import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { MyNetworkCircleCardMenu } from '../../network/circle-menu';
import ProfilePublicSidebar from '../sidebar';
import { NetworkListingNotFound } from '../../404';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
import { UserNetworkingActions } from 'v4/components/user-networking-actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getRoomIdFromLS } from 'v4/utils/utils';
import { useRouter } from 'next/router';
const ProfilePublicNetwork = () => {
  const {
    refetchConnections,
    connections,
    publicProfile,
    publicNetworkTab,
    setPublicNetworkTab,
    connectionsFetching,
    connectionsIsLoading,
    connectionsFetchNextPage,
    connectionsHasNextPage,
    connectionsCount,
    mutualConnections,
    refetchMutualConnections,
    mutualConnectionsIsFetching,
    mutualConnectionsIsLoading,
    mutualConnectionsFetchNextPage,
    mutualConnectionsHasNextPage,
    mutualConnectionsCount,

    otherUserThirdDegreeConnections,
    refetchOtherUserThirdDegreeConnections,
    otherUserThirdDegreeConnectionsIsFetching,
    otherUserThirdDegreeConnectionsIsLoading,
    otherUserThirdDegreeConnectionsFetchNextPage,
    otherUserThirdDegreeConnectionsHasNextPage,
    otherUserThirdDegreeConnectionsCount,
    otherUserSecondDegreeConnections,
    refetchOtherUserSecondDegreeConnections,
    otherUserSecondDegreeConnectionsIsFetching,
    otherUserSecondDegreeConnectionsIsLoading,
    otherUserSecondDegreeConnectionsFetchNextPage,
    otherUserSecondDegreeConnectionsHasNextPage,
    otherUserSecondDegreeConnectionsCount,
    loggedIn,
  } = useContext(PublicProfileContext);
  const {
    handshakeUser,
    handshakeLoading,
    isHandshaked,
    followUser,
    followLoading,
    unfollowUser,
    unfollowLoading,
    isFollowed,
    isHandshakedRequested,
    isFriend,
    allSuggestions,
    refetchSuggestions,
    unfriendLoading,
    selectedUser,
    setSelectedUser,
    userProfileInfo,
    filters = {},
  } = useContext(MyNetworkContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedChatUser, setSelectedChatUser] = useState()
  const [confirmAction, setConfirmAction] = useState(() => () => {});
  const { t } = useTranslator();
  const router = useRouter();
  const isUserInConnectionsAndFriend = (userId) => {
    // Check if connections array exists
    if (!connections || !connections.length) return false;
    
    // Find the user in connections array
    const foundUser = connections.some(connection => connection.id === userId);
    
    if (foundUser) {
      return foundUser;
    }
    
    return false;
  };
  const { startChatSingle } = useContext(MatrixContext);

  useEffect(() => {
    if (publicNetworkTab === 4) {
      refetchConnections();
    } else if (publicNetworkTab === 0) {
      refetchMutualConnections();
    } else if (publicNetworkTab === 1) {
      refetchOtherUserSecondDegreeConnections();
    } else if (publicNetworkTab === 2) {
      refetchOtherUserThirdDegreeConnections();
    }
  }, [publicProfile, publicNetworkTab]);



  return (
    <HStack spacing={4} alignItems="flex-start">
      <Box w="100%" top="5rem" maxH="90vh">
        <Heading
          fontSize="20px"
          fontWeight="400"
          color="brandPrimary.500"
          mb={3}
          px={[3, 0]}
        >
          {publicProfile?.first_name}&apos;s {t('profileNetwork.connection') || "connection"}
        </Heading>
        <Tabs
          index={publicNetworkTab}
          onChange={(index) => setPublicNetworkTab(index)}
        >
          {isMobile ? (
            <HStack w="100%" justifyContent="space-between" pe={3}>
              <TabList border="none">
                <Tab>{t('profileNetwork.mutual') || "Mutual"}</Tab>
                <Tab me={8}>
                  1<sup>st</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}
                </Tab>
              
              <Menu>
                <MenuButton variant="secondary">
                  <ThreeDotsIcon />
                </MenuButton>
                <MenuList>
                  <MenuItem>
                  <Tab>2<sup>nd</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}</Tab>
                  </MenuItem>
                  <MenuItem>
                    <Tab>3<sup>rd</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}</Tab>
                  </MenuItem>
                </MenuList>
              </Menu>
              </TabList>
            </HStack>
          ) : (
            <TabList border="none">
              <Tab>{t('profileNetwork.mutual') || "Mutual"}</Tab>
              <Tab>
                1<sup>st</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}
              </Tab>
              <Tab>
                2<sup>nd</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}
              </Tab>
              <Tab>
                3<sup>rd</sup>&nbsp;{t('profileNetwork.degree') || "Degree"}
              </Tab>
            </TabList>
          )}

          <TabPanels>
            <TabPanel px={0}>
              {/* Mutual Networks */}
              {mutualConnectionsIsLoading ? (
                <HStack justifyContent="center" minH="500px">
                  <Spinner />
                </HStack>
              ) : (
                <>
                  <Stack minH="500px">
                    {mutualConnections?.length ? (
                      <InfiniteScroll
                        dataLength={
                          mutualConnectionsCount ? mutualConnectionsCount : 10
                        }
                        next={mutualConnectionsFetchNextPage}
                        hasMore={mutualConnectionsHasNextPage}
                      >
                        <Wrap spacing={4} m="10px">
                          {mutualConnections?.map?.((cu, cuIndex) => (
                            <WrapItem
                              spacing={0}
                              key={cuIndex}
                              minW="160px"
                              maxW={['49%', '30%', '250px']}
                              flexGrow={['1', '1', 0]}
                              flexShrink={['1', '1', 0]}
                            >
                              <MyNetworkUserCardBordered
                                key={cuIndex}
                                user={cu}
                                actions={
                                  isFriend(cu) ? (
                                    <HStack justifyContent="center">
                                      <IconButton
                                        background="transparent"
                                        borderRadius="50%"
                                        border="1px solid #00000033"
                                        // onClick={(e) => startChatSingle(cu)}
                                        // onClick={() => {
                                        //   if (!cu?.connection?.chat_room_id) {
                                        //     setSelectedChatUser(cu)
                                        //     setConfirmAction(() => (newId) => {
                                        //       startChatSingle(cu)
                                        //     });
                                        //     onOpen();
                                        //   } else {
                                        //     startChatSingle(cu)
                                        //   }
                                        // }}
                                        onClick={() => {
                                          // const matrixUserId = getMatrixUserId(cu?.id);
                                          // setSelectedChatUser(cu)

                                          // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                                          //   setConfirmAction(() => (newId) => {
                                          //     startChatSingle({...cu, matrix_user_id: newId})
                                          //   });
                                          //   onOpen();
                                          // } else {
                                          //   if(!cu?.matrix_user_id){
                                          //     startChatSingle({...cu, matrix_user_id: matrixUserId})
                                          //   }else{
                                          //     startChatSingle(cu)
                                          //   }
                                          // }
                                          const roomId = getRoomIdFromLS(cu?.id);
                                          router.push(`/profile/message?user=${roomId}`);
                                        }}
                                      >
                                        <NetworkChatIcon width={20} height={20} />
                                      </IconButton>
                                      <MyNetworkCircleCardMenu user={cu} />
                                    </HStack>
                                  ) : (
                                    <UserNetworkingActions user={cu} justifyContent="center"
                                    showHandshakeOnly />
                                  )
                                }
                              />
                            </WrapItem>
                          ))}
                        </Wrap>
                      </InfiniteScroll>
                    ) : (
                      <HStack justifyContent="center">
                        <Stack alignItems="center">
                          <NetworkListingNotFound />
                          <Text>{t('profile.manageInvitations') || "Manage Invitations"}</Text>
                        </Stack>
                      </HStack>
                    )}
                  </Stack>
                </>
              )}
              {/* Mutual Networks */}
            </TabPanel>

            <TabPanel px={0}>
              {/* 1st Degree Networks */}
              {connectionsIsLoading ? (
                <HStack justifyContent="center" minH="500px">
                  <Spinner />
                </HStack>
              ) : (
                <>
                  <Stack minH="500px">
                    {connections?.length > 0 && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1 ? (
                      <InfiniteScroll
                        dataLength={connectionsCount ? connectionsCount : 10}
                        next={connectionsFetchNextPage}
                        hasMore={connectionsHasNextPage}
                      >
                        <Wrap spacing={4} m="10px">
                          {connections?.map?.((cu, cuIndex) => {
                            const isConnectionAndFriend = isUserInConnectionsAndFriend(cu.id);
                            return (
                            <WrapItem
                              key={cuIndex}
                              minW="160px"
                              maxW={['49%', '30%', '250px']}
                              flexGrow={['1', '1', 0]}
                              flexShrink={['1', '1', 0]}
                            >
                              <MyNetworkUserCardBordered
                                key={cuIndex}
                                user={cu}
                                actions={
                                  // userProfileInfo?.id === cu?.id
                                  isConnectionAndFriend ? (
                                    <HStack justifyContent="center">
                                      {userProfileInfo?.id !== cu?.id && <IconButton
                                        width="30px"
                                        height="40px"
                                        borderRadius="50%"
                                        border="1px solid #00000033"
                                        background={"transparent"}
                                        // onClick={(e) => startChatSingle(cu)}
                                        // onClick={() => {
                                        //   if (!cu?.connection?.chat_room_id) {
                                        //     setConfirmAction(() => (newId) => {
                                        //       startChatSingle(cu)
                                        //     });
                                        //     onOpen();
                                        //   } else {
                                        //     startChatSingle(cu)
                                        //   }
                                        // }}
                                        onClick={() => {
                                          // const matrixUserId = getMatrixUserId(cu?.id);
                                          // setSelectedChatUser(cu)

                                          // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                                          //   setConfirmAction(() => (newId) => {
                                          //     startChatSingle({...cu, matrix_user_id: newId})
                                          //   });
                                          //   onOpen();
                                          // } else {
                                          //   if(!cu?.matrix_user_id){
                                          //     startChatSingle({...cu, matrix_user_id: matrixUserId})
                                          //   }else{
                                          //     startChatSingle(cu)
                                          //   }
                                          // }
                                          const roomId = getRoomIdFromLS(cu?.id);
                                          router.push(`/profile/message?user=${roomId}`);
                                        }}
                                      >
                                        <NetworkChatIcon width={18} height={18} />
                                      </IconButton>}
                                      <MyNetworkCircleCardMenu user={cu} />
                                    </HStack>
                                  ) : (
                                    <UserNetworkingActions user={cu} justifyContent="center"
                                    showHandshakeOnly />
                                  )
                                }
                              />
                            </WrapItem>
                            );
                          })}
                        </Wrap>
                      </InfiniteScroll>
                    ) : (
                      <HStack justifyContent="center">
                        <Stack alignItems="center">
                          <NetworkListingNotFound />
                          <Text>{t('profile.manageInvitations') || "Manage Invitations"}</Text>
                        </Stack>
                      </HStack>
                    )}
                  </Stack>
                </>
              )}
              {/* 2nd Degree Networks */}
            </TabPanel>

            <TabPanel px={0}>
              {/* 2nd Degree Networks */}
              {otherUserSecondDegreeConnectionsIsLoading ? (
                <HStack justifyContent="center" minH="500px">
                  <Spinner />
                </HStack>
              ) : (
                <>
                  <Stack minH="500px">
                    {otherUserSecondDegreeConnections?.length && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1 ? (
                      <InfiniteScroll
                        dataLength={
                          otherUserSecondDegreeConnectionsCount
                            ? otherUserSecondDegreeConnectionsCount
                            : 10
                        }
                        next={otherUserSecondDegreeConnectionsFetchNextPage}
                        hasMore={otherUserSecondDegreeConnectionsHasNextPage}
                      >
                        <Wrap spacing={4} m="10px">
                          {otherUserSecondDegreeConnections?.map?.(
                            (cu, cuIndex) => (
                              <WrapItem
                                key={cuIndex}
                                minW="160px"
                                maxW={['49%', '30%', '250px']}
                                flexGrow={['1', '1', 0]}
                                flexShrink={['1', '1', 0]}
                              >
                                <MyNetworkUserCardBordered
                                  key={cuIndex}
                                  user={cu}
                                  actions={
                                    isFriend(cu) ? (
                                      <HStack justifyContent="center">
                                        <IconButton
                                          // onClick={(e) => startChatSingle(cu)}
                                          // onClick={() => {
                                          //   if (!cu?.connection?.chat_room_id) {
                                          //     setConfirmAction(() => (newId) => {
                                          //       startChatSingle(cu)
                                          //     });
                                          //     onOpen();
                                          //   } else {
                                          //     startChatSingle(cu)
                                          //   }
                                          // }}  
                                          onClick={() => {
                                            // const matrixUserId = getMatrixUserId(cu?.id);
                                            // setSelectedChatUser(cu)

                                            // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                                            //   setConfirmAction(() => (newId) => {
                                            //     startChatSingle({...cu, matrix_user_id: newId})
                                            //   });
                                            //   onOpen();
                                            // } else {
                                            //   if(!cu?.matrix_user_id){
                                            //     startChatSingle({...cu, matrix_user_id: matrixUserId})
                                            //   }else{
                                            //     startChatSingle(cu)
                                            //   }
                                            // }
                                            const roomId = getRoomIdFromLS(cu?.id);
                                            router.push(`/profile/message?user=${roomId}`);
                                          }}
                                        >
                                          <ChatIcon width={20} height={20} />
                                        </IconButton>
                                        <MyNetworkCircleCardMenu user={cu} />
                                      </HStack>
                                    ) : (
                                      <UserNetworkingActions user={cu} justifyContent="center"
                                    showHandshakeOnly />
                                    )
                                  }
                                />
                              </WrapItem>
                            )
                          )}
                        </Wrap>
                      </InfiniteScroll>
                    ) : (
                      <HStack justifyContent="center">
                        <Stack alignItems="center">
                          <NetworkListingNotFound />
                          <Text>{t('profile.manageInvitations') || "Manage Invitations"}</Text>
                        </Stack>
                      </HStack>
                    )}
                  </Stack>
                </>
              )}
              {/* 2nd Degree Networks */}
            </TabPanel>
            <TabPanel px={0}>
              {/* 3rd Degree Networks */}
              {otherUserThirdDegreeConnectionsIsLoading ? (
                <HStack justifyContent="center" minH="500px">
                  <Spinner />
                </HStack>
              ) : (
                <>
                  <Stack minH="500px">
                    {otherUserThirdDegreeConnections?.length && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1 ? (
                      <InfiniteScroll
                        dataLength={
                          otherUserThirdDegreeConnectionsCount
                            ? otherUserThirdDegreeConnectionsCount
                            : 10
                        }
                        next={otherUserThirdDegreeConnectionsFetchNextPage}
                        hasMore={otherUserThirdDegreeConnectionsHasNextPage}
                      >
                        <Wrap spacing={4} m="10px">
                          {otherUserThirdDegreeConnections?.map?.(
                            (cu, cuIndex) => (
                              <WrapItem
                                key={cuIndex}
                                minW="160px"
                                maxW={['49%', '30%', '250px']}
                                flexGrow={['1', '1', 0]}
                                flexShrink={['1', '1', 0]}
                              >
                                <MyNetworkUserCardBordered
                                  key={cuIndex}
                                  user={cu}
                                  actions={
                                    isFriend(cu) ? (
                                      <HStack justifyContent="center">
                                        <IconButton
                                          // onClick={(e) => startChatSingle(cu)}
                                          // onClick={() => {
                                          //   if (!cu?.connection?.chat_room_id) {
                                          //     setConfirmAction(() => (newId) => {
                                          //       startChatSingle(cu)
                                          //     });
                                          //     onOpen();
                                          //   } else {
                                          //     startChatSingle(cu)
                                          //   }
                                          // }}
                                          onClick={() => {
                                            // const matrixUserId = getMatrixUserId(cu?.id);
                                            // setSelectedChatUser(cu)

                                            // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                                            //   setConfirmAction(() => (newId) => {
                                            //     startChatSingle({...cu, matrix_user_id: newId})
                                            //   });
                                            //   onOpen();
                                            // } else {
                                            //   if(!cu?.matrix_user_id){
                                            //     startChatSingle({...cu, matrix_user_id: matrixUserId})
                                            //   }else{
                                            //     startChatSingle(cu)
                                            //   }
                                            // }
                                            const roomId = getRoomIdFromLS(cu?.id);
                                            router.push(`/profile/message?user=${roomId}`);
                                          }}
                                        >
                                          <ChatIcon width={20} height={20} />
                                        </IconButton>
                                        <MyNetworkCircleCardMenu user={cu} />
                                      </HStack>
                                    ) : (
                                      <UserNetworkingActions user={cu} justifyContent="center"
                                    showHandshakeOnly />
                                    )
                                  }
                                />
                              </WrapItem>
                            )
                          )}
                        </Wrap>
                      </InfiniteScroll>
                    ) : (
                      <HStack justifyContent="center">
                        <Stack alignItems="center">
                          <NetworkListingNotFound />
                          <Text>{t('profile.manageInvitations') || "Manage Invitations"}</Text>
                        </Stack>
                      </HStack>
                    )}
                  </Stack>
                </>
              )}
              {/* 3rd Degree Networks */}
            </TabPanel>

            <GlobalMatrixPopup
              isOpen={isOpen}
              onClose={onClose}
              onConfirm={confirmAction}
              selectedUserId={selectedChatUser?.id}
            />
          </TabPanels>
        </Tabs>
      </Box>
      {/* <ProfilePublicSidebar /> */}
    </HStack>
  );
};

export default ProfilePublicNetwork;
